<div class="p-4 surface-card shadow-2 border-round">
  <p-toolbar styleClass="mb-4 gap-2 border-none surface-section p-0">
    <ng-template pTemplate="left">
      <div class="flex gap-2">
        <p-button pRipple label="Nuevo" icon="pi pi-plus" severity="primary" class="p-button-sm"
          (click)="openNew()"></p-button>
        <p-button pRipple label="Eliminar" severity="danger" icon="pi pi-trash" class="p-button-danger p-button-sm"
          (click)="deleteSelectedRows()" [outlined]="true" [disabled]="!selected || !selected.length"></p-button>
      </div>
    </ng-template>

    <ng-template pTemplate="right">
      @if (cardTemplate) {
      <div class="flex align-items-center gap-2 mr-2">
        <p-button icon="pi pi-list" [text]="true" [rounded]="true"
          [severity]="layout === 'list' ? 'primary' : 'secondary'" (onClick)="layout = 'list'"></p-button>
        <p-button icon="pi pi-th-large" [text]="true" [rounded]="true"
          [severity]="layout === 'grid' ? 'primary' : 'secondary'" (onClick)="layout = 'grid'"></p-button>
      </div>
      }
      <p-button pRipple label="Exportar CSV" icon="pi pi-file-export" [text]="true" severity="secondary"
        (onClick)="table?.exportCSV()"></p-button>
    </ng-template>
  </p-toolbar>

  @if (layout === 'list') {
  <p-table #table [loading]="loading" [loadingIcon]="'pi pi-spin pi-spinner '" [columns]="columns" [value]="data"
    [(selection)]="selected" [exportHeader]="'customExportHeader'"
    (onPage)="onPage($event)" rowHover="true" responsiveLayout="stack" [breakpoint]="'960px'"
    styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped" [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="caption">
      <p-iconField iconPosition="left" class="ml-auto">
        <p-inputIcon>
          <i class="pi pi-search"></i>
        </p-inputIcon>
        <input pInputText id="global_filter" class="p-input text-sm" type="text" (input)="onGlobalFilter($event)"
          placeholder="Buscar" />
      </p-iconField>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width: 3rem">
          <p-tableHeaderCheckbox />
        </th>
        @for (column of columns; track $index) {
        <th [pSortableColumn]="column.sortable ? column.field : null">
          <div class="flex align-items-center">
            {{ column.header }}
            @if (column.sortable) {
            <p-sortIcon [field]="column.field" />
            }
          </div>
        </th>
        }
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr class="transition-colors transition-duration-200 hover:surface-50 cursor-pointer" (click)="onRowClick($event, rowData)">
        <td>
          <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
        </td>
        @for (column of columns; track $index) {
        @if (isCategoriesColumn(column)) {
        <td>
          @for (row of rowData[column.field]; track $index) {
          <app-chip class="mr-2" [status]="row" [small]="true"> </app-chip>
          }
        </td>
        } @else if (isStatusColumn(column)) {
        <td>
          <app-chip [status]="rowData[column.field]" [small]="true"> </app-chip>
        </td>
        } @else if (column.field === 'name') {
        <td class="font-bold text-900">
          {{ rowData[column.field] }}
        </td>
        } @else if (column.field === 'email' || column.field === 'phone') {
        <td class="text-500">
          {{ rowData[column.field] }}
        </td>
        } @else {
        <td class="text-700">
          {{ rowData[column.field] }}
        </td>
        }
        }
        <td class="text-center">
          <p-button icon="pi pi-pencil" [text]="true" [rounded]="true" severity="secondary"
            (onClick)="activeItem = rowData; onEdit(rowData)" pTooltip="Editar" tooltipPosition="top">
          </p-button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="flex justify-content-end align-items-center">
        <span class="text-sm text-color-secondary">
          Total: {{ totalRecords }}
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4">Sin registros</td>
      </tr>
    </ng-template>
  </p-table>
  } @else {
  <div class="grid">
    @for (item of data; track $index) {
    <div class="col-12 sm:col-6 lg:col-4 xl:col-3">
      <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: item }"></ng-container>
    </div>
    }
  </div>
  }
  <p-paginator [rowsPerPageOptions]="[10, 20, 50]" [rows]="10" [showJumpToPageInput]="true"
    [totalRecords]="totalRecords" (onPageChange)="onPage($event)"></p-paginator>
  <p-menu #menu [popup]="true" [model]="menuItems"></p-menu>
</div>